export const reviewsData = [
  {
    id: 1,
    author_name: "Rk Support",
    text: "We highly appreciated towards your team,who are always support us. Your contribution are invaluable. You consistently exceed expectations - thank you for your incredible effort! Your positive attitude and strong work ethic are an inspiration for everyone.Thank you for always giving your best effort.",
  },
  {
    id: 2,
    author_name: "DHEERAJ KUMAR",
    text: "time watch company is a good company, service is good in the matter of baggage scanner. shivam is a good engineer, since time he has come to see the baggage. we are very happy with their service. #indian banaras railway station #time watch infocom pvt ltd",
  },
  {
    id: 3,
    author_name: "Navneet",
    text: "It's really grate service and their customer service it good assist us with effective time watch company is a good company, service .Lalit kumar is a good customer support representative,we are very happy with their service. Thankyou so much",
  },
  {
    id: 4,
    author_name: "Vedant Yadav",
    text: "Mr Shivam have delivered the Timewatch Infocom Xray machine at Leh, India in record timing. The service was quite satisfactory. Looking forward for more with firm Regards.",
  },
];
